<template>
  <div>
    <div class="header">
      <div class="logo">
        <LogoComponent></LogoComponent>

      </div>
      <a class="about" href="/">关于我们</a>
    </div>
    <Banner4></Banner4>
    
  </div>
</template>
<script>
import LogoComponent from '@/views/pc/logoComponentsTem.vue'
import Banner4 from '@/views/pc/banner4Tem.vue'
export default {
  components: {
    LogoComponent,
    Banner4
  },
  data () {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
  .header {
    width: 100vw;
    height: 100px;
    background-color: rgba(#EE5A22, 0.6);
    // background-color: #EE5A22;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    .about {
      width: 120px;
      font-size: 22px;
      line-height: 50px;
      box-sizing: border-box;
      // margin-left: 200px;
      border-bottom: 1px solid #ffffff;
      color: #ffffff;
      text-align: center;
    }
  }
  .tips {
		// font-size: 10px;
    background-color: #EE5A22;
		color: #E2E2E2;
		font-weight: 400;
		text-decoration:none;
		width: 100%;
		// background-color: red;
		text-align: center;
		font-size: 20px;
		// margin-top: 5px;
		line-height: 20px;
    box-sizing: border-box;
    padding-bottom: 100px;
		a {
			text-decoration:none;
			color: #E2E2E2;
			font-weight: 400;
		}
	}

</style>